export default "__VITE_ASSET__CXi1O9I$__"